import React from 'react';
import { Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import { homePage } from 'config/config';

const Logo = ({ color, ...props }) => {
  const logoUrl = '/images/BRP-Digital_and_Campaign_Logo-W-RGB.svg';

  return (
    <NavLink to={homePage} style={{ height: '50px' }}>
      <CmtImage src={logoUrl} alt="logo" style={{ height: 50 }} />
    </NavLink>
  );
};

export default Logo;
